import { useState } from "react";

import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import { ListItemIcon, ListItemText } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import { alpha } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import useAuth from "src/auth/useAuth";
import UserAvatar from "src/components/UserAvatar";
import RouterLink from "src/router/router-link";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { user } = useAuth();
  const handleOpen = (event: any) => {
    setOpen(event.currentTarget);
  };
  const navigate = useNavigate();

  const handleClose = (event: any, route: string) => {
    event.stopPropagation();
    setOpen(null);
    if (route !== "backdropClick") {
      setTimeout(() => navigate(route), 300);
    }
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        id="account-popover"
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open
            ? {
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
              }
            : {}),
        }}
      >
        <UserAvatar name={user?.email ?? ""} />
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.email.split("@")[0]}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        {user?.roles.includes("admin") && (
          <MenuItem onClick={(e) => handleClose(e, "/metadata")}>
            <ListItemIcon>
              <SettingsApplicationsOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Meta Data</ListItemText>
          </MenuItem>
        )}

        <Divider sx={{ borderStyle: "dashed", m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          id="btn-logout"
          sx={{
            typography: "body2",
            color: (theme: any) => theme.palette.error.main,
            py: 1.5,
          }}
          component={RouterLink}
          href="https://superfruiter.click/logout"
        >
          <ListItemIcon>
            <LogoutOutlinedIcon color={"error"} fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Popover>
    </>
  );
}
